"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Testing-&-Map-Views",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group-3",
    transform: "translate(-15.000000, -19.000000)",
    fill: props.fill
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15,31.6671296 L15,35 L18.3328704,35 L28.1626163,25.1702541 L24.8297459,21.8373837 L15,31.6671296 L15,31.6671296 Z M30.7400361,22.5928343 C31.0866546,22.2462158 31.0866546,21.6862936 30.7400361,21.339675 L28.660325,19.2599639 C28.3137064,18.9133454 27.7537842,18.9133454 27.4071657,19.2599639 L25.7807249,20.8864047 L29.1135953,24.2192751 L30.7400361,22.5928343 L30.7400361,22.5928343 Z",
    id: "Shape"
  }))));
};

exports["default"] = _default;